import { Button, Input, Tooltip } from 'antd';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import React from 'react';
import TabToolbar from '../../../components/styled/TabToolbar';
import { ADD_UNAUTHORIZED_MESSAGE } from './utils/constants';

const StyledInput = styled(Input)`
    border-radius: 70px;
    max-width: 300px;
`;

type Props = {
    t: (key: string) => string;
    addQueryDisabled: boolean;
    /** When provided, shown when add button is disabled (e.g. RBAC permission message). */
    addQueryDisabledTooltip?: string;
    onAddQuery: () => void;
    onChangeSearch: (text: any) => void;
    isReadOnly?: boolean;
};

export default function QueriesTabToolbar({
    addQueryDisabled,
    addQueryDisabledTooltip,
    onAddQuery,
    onChangeSearch,
    isReadOnly,
    t,
}: Props) {
    const getTooltipTitle = () => {
        if (addQueryDisabledTooltip) return addQueryDisabledTooltip;
        if (isReadOnly) return t('ASSET_MARKED_AS_READ_ONLY');
        if (addQueryDisabled) return ADD_UNAUTHORIZED_MESSAGE;
        return t('Add a highlighted query');
    };

    return (
        <TabToolbar>
            <Tooltip placement="right" title={getTooltipTitle()} overlayClassName="f-tooltip-white">
                <Button
                    disabled={addQueryDisabled}
                    type="text"
                    onClick={onAddQuery}
                    data-testid="add-query-button"
                    aria-label={t('Add Query')}
                >
                    <PlusOutlined aria-hidden="true" /> {t('Add Query')}
                </Button>
            </Tooltip>
            <StyledInput
                placeholder={t('Search in queries')}
                onChange={onChangeSearch}
                allowClear
                prefix={<SearchOutlined />}
                data-testid="search-query-input"
            />
        </TabToolbar>
    );
}
